import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a48yhkcyr1: FaireBrandEntity = {
  token: "b_a48yhkcyr1",
  type: "brand",
  name: "Crazy Socks",
  avatarUrl:
    "https://cdn.faire.com/fastly/13da9aacaf2ba9aff3753be67cfe6f648ca7e411468401b61579ceb788fd8b17.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/882d39a59624e912e36024fff8c29738552ce727104df159c656a8278fd00b8e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/13da9aacaf2ba9aff3753be67cfe6f648ca7e411468401b61579ceb788fd8b17.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/882d39a59624e912e36024fff8c29738552ce727104df159c656a8278fd00b8e.png",
  location: "Clearwater, FL, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 81,
  isInsider: true,
  description:
    "Crazy Socks offers the widest range of fun and comfortable socks at the most affordable price, guaranteed! \nPLEASE NOTE WE DO NOT ALLOW ANY AMAZON, EBAY OR OTHER 3RD PARTY SALES\n",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:15.045Z",
    importedBy: "entity-db-cli",
  },
};
